import React from "react";

import { Alert, SvgIcon, Typography } from "@mui/material";

import { FallbackLoader } from "components";

import { AssistantBookIcon } from "../../assets";
import { AssistantBody, AssistantMutedText } from "../../styles";
import AssistantAnswerSection from "../answer-section";
import AssistantGuideList from "../guide-list";
import AssistantWalkthroughFeatureList from "../walkthrough-feature-list";
import {
  AssistantPendingResponse,
  AssistantQuestion,
  AssistantWelcome,
} from "./styles";
import { IAssistantConversationSectionProps } from "./types";

const AssistantConversationSection: React.FC<IAssistantConversationSectionProps> =
  ({
    walkthroughFeatures,
    pendingWalkthroughFeatureIds,
    onDismissWalkthroughFeature,
    submittedQuestion,
    answer,
    pending,
    completed,
    onDismissCompletion,
    onChoose,
  }) => {
    return (
      <AssistantBody data-assistant-content>
        {completed && (
          <Alert
            severity="success"
            closeText="Dismiss walkthrough completion"
            onClose={onDismissCompletion}
          >
            Walkthrough finished.
          </Alert>
        )}
        <AssistantWalkthroughFeatureList
          walkthroughFeatures={walkthroughFeatures}
          pendingIds={pendingWalkthroughFeatureIds}
          onDismiss={onDismissWalkthroughFeature}
        />
        {!submittedQuestion && !walkthroughFeatures.length && (
          <AssistantWelcome>
            <SvgIcon component={AssistantBookIcon} inheritViewBox />
            <Typography variant="h8" component="h3">
              What would you like to do?
            </Typography>
            <AssistantMutedText variant="subtitle7">
              Ask about a task or feature. I can explain the steps using your
              user guides.
            </AssistantMutedText>
          </AssistantWelcome>
        )}
        {submittedQuestion && (
          <AssistantQuestion variant="subtitle8">
            {submittedQuestion}
          </AssistantQuestion>
        )}
        {pending && (
          <AssistantPendingResponse
            role="status"
            aria-label="Looking through your guides"
          >
            <FallbackLoader />
          </AssistantPendingResponse>
        )}
        {answer && (
          <AssistantAnswerSection
            answer={answer}
            pending={pending}
            onChoose={onChoose}
          />
        )}
        {Boolean(answer?.guides.length) && (
          <AssistantGuideList guides={answer?.guides ?? []} />
        )}
      </AssistantBody>
    );
  };

export default AssistantConversationSection;
